//to connect to backend using axios and integrate with react
import axios from "axios";
const client = axios.create({
  baseURL: "https://salesbudget.gsk.com/apiprod/"
  // baseURL: "http://localhost:8000/"
});
export default function axiosRequestProd(options) {
  const onSuccess = function (response) {
    return response;
  };

  const onError = function (error) {
    if (error.response) {
      return error.response.data?.length > 100
        ? error.response.data.substring(0, 100) + " ..."
        : error.response.data;
    } else {
      return error.message.length > 100
        ? error.message.substring(0, 100) + " ..."
        : error.message;
    }
  };

  return client(options).then(onSuccess).catch(onError);
}
